import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { trackPageview, onDocumentClick } from '@/lib/siteMetrics';

/** Mounted once in App: page views on route changes and service-link clicks. Renders nothing; administrators are not counted. */
export function SiteMetricsRuntime() {
  const location = useLocation();
  const { user, loading } = useAuth();
  const isAdmin = user?.role === 'admin';
  // Wait for the session check: an administrator opening the site must never be counted for a split second.
  useEffect(() => { if (!loading) trackPageview(location.pathname, isAdmin); }, [location.pathname, isAdmin, loading]);
  useEffect(() => {
    const handler = (e) => onDocumentClick(e, isAdmin);
    document.addEventListener('click', handler, { passive: true, capture: true });
    return () => document.removeEventListener('click', handler, { capture: true });
  }, [isAdmin]);
  return null;
}

export default SiteMetricsRuntime;
